import React from 'react';

const Mail = () => (
	<svg width="24" height="19" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" aria-labelledby="email-icon"><title id="email-icon">Email to a Friend</title><g fillRule="evenodd"><path d="M21.658 4.403H2.393c2.06 1.93 8.782 8.235 9.632 9.033l9.633-9.033M15.985 11.925l6.848 6.42V5.503"></path><path d="M12.026 15.638L9.24 13.025l-6.846 6.422h19.264c-1.304-1.226-4.47-4.195-6.845-6.422l-2.787 2.613zM1.22 5.503v12.842l6.846-6.42"></path></g></svg>
)

export default Mail;
